class ExitIntentPopup {
	constructor() {}
	init($root = document) {
		this.exitPopupButton = document.querySelector(
			"[data-action=popup_redirecting]"
		);
		this.exitPopupEl = document.querySelector(
			"#intent-exit[data-popup=redirecting]"
		);

		if (this.exitPopupEl) {
			this.popupBtnsClose =
				this.exitPopupEl.querySelectorAll("[data-popup-close]");
			if (
				!document.body.classList.contains("is-mobile") &&
				!document.body.classList.contains("is-tablet")
			) {
				const mouseEvent = (e) => {
					const shouldShowExitIntent =
						!e.toElement && !e.relatedTarget && e.clientY < 10;
					if (shouldShowExitIntent) {
						document.removeEventListener("mouseout", mouseEvent);
						this.exitPopupEl.classList.add("is-active");
					}
				};

				const exit = (e) => {
					if (e.target.matches("[data-popup-close]")) {
						this.exitPopupEl.classList.remove("is-active");
					}
				};

				setTimeout(() => {
					document.addEventListener("mouseout", mouseEvent);
					document.addEventListener("click", exit);
				}, 3000);
			}
		}
	}
}

const exitIntentPopup = new ExitIntentPopup();

export { exitIntentPopup };
